import { useState } from "react";

function DuoInfo() {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="detail-info">
      <h1 style={{textAlign: 'center', fontSize: '30px'}}>
        <strong>iPhone Duo</strong>
      </h1>

      <div className={`content ${showMore ? "expanded" : "collapsed"}`}>
        <p>
          <strong>iPhone Duo</strong> là chiếc iPhone màn hình gập đầu tiên của
          Apple, mở ra hướng sử dụng hoàn toàn khác so với thiết kế iPhone
          truyền thống. Thiết bị kết hợp màn hình trong Super Retina XDR 7,6
          inch với màn hình ngoài 5,4 inch, chip A20 Pro, hệ thống camera 48MP
          Dual Fusion, pin đôi và giao diện iOS được tối ưu cho nhiều tư thế gập
          khác nhau.
        </p>

        <p>
          Điểm đáng chú ý của iPhone Duo không chỉ nằm ở khả năng gập. Khi mở
          máy, người dùng có một không gian hiển thị lớn hơn 50% so với iPhone
          18 Pro Max, phù hợp hơn cho xem nội dung, chơi game, đa nhiệm và làm
          việc. Khi gập lại, màn hình ngoài vẫn có thể đảm nhiệm nhiều tác vụ
          hàng ngày như một chiếc iPhone thông thường.
        </p>

        {showMore && (
          <>
            <h2>
              <strong style={{fontSize: '22px'}}>iPhone Duo có gì mới?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/thiet-ke-iphone-duo.webp"
                alt="thiet-ke-iphone-duo"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone Duo đánh dấu lần đầu Apple đưa thiết kế gập lên iPhone.
              Thay vì chỉ mở rộng kích thước màn hình, Apple thiết kế lại cả
              phần cứng lẫn trải nghiệm iOS để tận dụng các trạng thái đóng, mở
              và đặt máy ở nhiều góc khác nhau.
            </p>

            <p>
              Những điểm nổi bật của iPhone Duo gồm màn hình gập 7,6 inch, màn
              hình ngoài 5,4 inch, khung và bản lề titan Cấp 5, chip A20 Pro,
              camera 48MP Dual Fusion, hệ thống pin đôi, Touch ID và khả năng hỗ
              trợ Apple Pencil USB-C.
            </p>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "16px",
              }}
            >
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Hạng mục
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    iPhone Duo
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màn hình trong
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Super Retina XDR OLED gập 7,6 inch
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màn hình ngoài
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Super Retina XDR OLED 5,4 inch
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Tần số quét
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    ProMotion thích ứng lên đến 120Hz trên cả hai màn hình
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Chip
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Apple A20 Pro
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    CPU
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    6 lõi
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    GPU
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    7 lõi với Neural Accelerators
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera sau
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Dual Fusion: Main + Ultra Wide
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera trước ngoài
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    12MP Center Stage
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera màn hình trong
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera FaceTime dưới màn hình
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Dung lượng
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    256GB, 512GB, 1TB, 2TB
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Sinh trắc học
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Touch ID tích hợp nút sườn
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    SIM
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Chỉ hỗ trợ eSIM
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Pin
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Hệ thống pin đôi
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Xem video
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Đến 31 giờ với màn hình trong, 44 giờ với màn hình ngoài
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Kháng nước, bụi
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    IP68
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màu sắc
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Trời Đêm, Trắng Ánh Sao
                  </td>
                </tr>
              </tbody>
            </table>

            <h2>
              <strong style={{fontSize: '22px'}}>
                Thiết kế gập thay đổi cách sử dụng iPhone như thế nào?
              </strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-thiet-ke-man-hinh-gap.webp"
                alt="iphone-duo-thiet-ke-man-hinh-gap"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Khác biệt lớn nhất của iPhone Duo nằm ở khả năng chuyển đổi giữa
              một thiết bị nhỏ gọn khi đóng và không gian hiển thị lớn khi mở.
              Đây cũng là yếu tố khiến Duo cần được nhìn nhận khác với iPhone 18
              Pro hoặc Pro Max.
            </p>

            <p>
              Khi mở hoàn toàn, thiết bị có kích thước 164,6 x 117,8 x 5,2 mm.
              Khi gập lại, chiều rộng giảm còn 84,1 mm và độ dày tăng lên 11,3
              mm. Trọng lượng của máy là 254g.
            </p>

            <p>
              Apple sử dụng titan Cấp 5 cho khung máy và phần ốp bản lề, Ceramic
              Shield 2 ở mặt trước và Ceramic Shield ở mặt sau. Màn hình trong
              được bổ sung lớp phủ chống trầy xước.
            </p>

            <p>
              Thiết bị đạt chuẩn IP68 trong điều kiện thử nghiệm của Apple, với
              khả năng chịu nước ở độ sâu tối đa 6 mét trong tối đa 30 phút.
            </p>

            <h3>
              <strong>
                Nhiều tư thế sử dụng hơn một chiếc iPhone thông thường
              </strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-Flexible-views.webp"
                alt="iphone-duo-Flexible-views"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Khả năng gập giúp iPhone Duo hoạt động ở nhiều tư thế khác nhau
              thay vì chỉ cầm theo chiều dọc hoặc ngang.
            </p>

            <p>
              Người dùng có thể đặt máy mở vuông góc trên bàn để xem video, theo
              dõi bài tập hoặc gọi FaceTime mà không cần giá đỡ. Khi dựng máy,
              phần màn hình có thể phục vụ các nội dung như đồng hồ, ảnh hoặc
              tiện ích.
            </p>

            <p>
              Điều này biến bản lề từ một thành phần cơ khí thành một phần của
              trải nghiệm sử dụng. Đây cũng là khác biệt quan trọng giữa Duo và
              việc đơn thuần tạo ra một chiếc iPhone có màn hình lớn hơn.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>
                Màn hình trong 7,6 inch lớn nhất từng có trên iPhone
              </strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/cong-nghe-man-hinh-nano-tren-iphone-duo.webp"
                alt="cong-nghe-man-hinh-nano-tren-iphone-duo"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Khi mở ra, iPhone Duo sử dụng màn hình{" "}
              <strong>Super Retina XDR OLED gập 7,6 inch</strong> với độ phân
              giải 1878 x 2670 pixel và mật độ điểm ảnh 430 ppi.
            </p>

            <p>
              Theo Apple, diện tích màn hình này lớn hơn 50% so với iPhone 18
              Pro Max. Không gian bổ sung đặc biệt có giá trị khi xem phim, chơi
              game, đọc tài liệu hoặc làm việc với nhiều nội dung cùng lúc.
            </p>

            <p>
              Màn hình trong sử dụng cấu trúc nhiều lớp siêu mỏng và bề mặt
              Nano-texture được Apple thiết kế để giảm độ chói và phản chiếu.
              Camera FaceTime cũng được đặt dưới màn hình nhằm duy trì bề mặt
              hiển thị liền mạch hơn khi không sử dụng.
            </p>

            <h3>
              <strong>
                Màn hình ngoài 5,4 inch dùng như một chiếc iPhone thông thường
              </strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-1-nua-mat-truoc.webp"
                alt="iphone-duo-1-nua-mat-truoc"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Khi không cần mở máy, người dùng có thể sử dụng màn hình ngoài
              Super Retina XDR OLED 5,4 inch với độ phân giải 1398 x 2034 pixel
              và mật độ điểm ảnh 460 ppi.
            </p>

            <p>
              Apple cho biết diện tích màn hình ngoài tương đương hơn 90% màn
              hình của iPhone 18 Pro. Vì vậy, những tác vụ nhanh như nhắn tin,
              kiểm tra thông báo, gọi điện hoặc sử dụng ứng dụng không nhất
              thiết phải mở thiết bị.
            </p>

            <p>
              Điểm quan trọng của thiết kế này là Duo không buộc người dùng phải
              sử dụng màn hình lớn trong mọi tình huống. Màn hình ngoài phục vụ
              các tác vụ nhanh, còn màn hình trong tạo lợi thế khi cần nhiều
              không gian hơn.
            </p>

            <h3>
              <strong>Cả hai màn hình đều có ProMotion 120Hz</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-suc-manh-tran-man-hinh.webp"
                alt="iphone-duo-suc-manh-tran-man-hinh"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Cả màn hình trong và ngoài đều hỗ trợ ProMotion với tần số quét
              thích ứng lên đến 120Hz, Always-On Display, HDR, True Tone và dải
              màu rộng P3.
            </p>

            <p>
              Độ sáng ngoài trời tối đa được Apple công bố ở mức 3.000 nit. Điều
              này giúp trải nghiệm giữa màn hình trong và ngoài giữ được tính
              nhất quán hơn thay vì chỉ màn hình chính mới sở hữu thông số cao
              cấp.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>
                iPhone Duo có phù hợp để đa nhiệm và làm việc không?
              </strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-chia-tab-2-man.webp"
                alt="iphone-duo-chia-tab-2-man"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Màn hình lớn chỉ thực sự có giá trị nếu phần mềm tận dụng được
              không gian bổ sung. Vì vậy, Apple thiết kế lại trải nghiệm iOS
              trên Duo để hỗ trợ nhiều cách bố trí ứng dụng và trạng thái gập
              khác nhau.
            </p>

            <p>
              Người dùng có thể mở các ứng dụng song song trong những tình huống
              phù hợp, giúp giảm việc liên tục chuyển qua lại giữa hai ứng dụng.
              Ví dụ, có thể tham khảo thông tin ở một bên trong khi thao tác ở
              ứng dụng khác hoặc theo dõi cuộc gọi FaceTime trong lúc sử dụng
              màn hình còn lại.
            </p>

            <p>
              Với nhóm người dùng thường xuyên đọc tài liệu, xử lý email, họp
              trực tuyến hoặc quản lý nhiều ứng dụng, màn hình 7,6 inch mang lại
              lợi ích khác hẳn việc chỉ tăng kích thước chữ và nội dung.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>iPhone Duo hỗ trợ Apple Pencil</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-khi-mo-gallery-rong.webp"
                alt="iphone-duo-khi-mo-gallery-rong"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Apple xác nhận iPhone Duo tương thích với{" "}
              <strong>Apple Pencil USB-C</strong>. Đây là một khác biệt đáng chú
              ý so với các mẫu iPhone truyền thống.
            </p>

            <p>
              Khi kết hợp màn hình 7,6 inch với Apple Pencil, Duo có thể phù hợp
              hơn cho các tác vụ như ghi chú, đánh dấu tài liệu, phác thảo hoặc
              thao tác chính xác trên màn hình.
            </p>

            <p>
              Tuy nhiên, Apple cho biết khả năng hỗ trợ Apple Pencil sẽ được
              triển khai sau trong năm. Vì vậy, người dùng nên kiểm tra tình
              trạng hỗ trợ thực tế tại thời điểm sử dụng thay vì coi đây là tính
              năng sẵn có ngay từ ngày đầu.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Chip A20 Pro mang hiệu năng Pro lên thiết kế gập</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-su-dung-chip-a20-pro.webp"
                alt="iphone-duo-su-dung-chip-a20-pro"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone Duo sử dụng <strong>chip A20 Pro</strong> với CPU 6 lõi gồm
              2 lõi hiệu năng cao và 4 lõi tiết kiệm điện, GPU 7 lõi tích hợp
              Neural Accelerators và Bộ Đôi Neural Engine 16 lõi.
            </p>

            <p>
              Theo Apple, CPU 6 lõi nhanh hơn đến 20% so với A19 Pro và băng
              thông bộ nhớ cao hơn đến 50% trong các điều kiện thử nghiệm phù
              hợp.
            </p>

            <p>
              Sức mạnh này phục vụ không chỉ game và các ứng dụng nặng mà còn
              những workflow AI và đa nhiệm trên màn hình lớn.
            </p>

            <h3>
              <strong>Tản nhiệt buồng hơi trên iPhone Duo</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-chip-a-20-pro-sieu-mat.webp"
                alt="iphone-duo-chip-a-20-pro-sieu-mat"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Apple trang bị hệ thống quản lý nhiệt sử dụng buồng hơi trên
              iPhone Duo. Đây là thành phần quan trọng với một thiết bị có thiết
              kế gập, bởi không gian bên trong được chia thành hai nửa và phải
              đồng thời chứa pin, màn hình, bản lề cùng các linh kiện xử lý.
            </p>

            <p>
              Hệ thống tản nhiệt hỗ trợ A20 Pro duy trì hiệu năng tốt hơn trong
              các phiên chơi game hoặc những tác vụ đòi hỏi nhiều tài nguyên.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Apple Intelligence và Siri AI trên iPhone Duo</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-siri-ai-thong-minh-va-ca-nhan-hoa.webp"
                alt="iphone-duo-siri-ai-thong-minh-va-ca-nhan-hoa"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              A20 Pro cùng Bộ Đôi Neural Engine 16 lõi tạo nền tảng cho Apple
              Intelligence và Siri AI.
            </p>

            <p>
              Apple định hướng Siri AI trở thành trợ lý cá nhân hiểu ngữ cảnh
              tốt hơn, giao tiếp tự nhiên hơn và tích hợp sâu với các ứng dụng.
              Không gian màn hình lớn của Duo cũng tạo thêm cách hiển thị và
              tương tác với các tính năng AI khi thực hiện nhiều tác vụ.
            </p>

            <p>
              Tuy nhiên, Siri AI mới được Apple công bố sẽ ra mắt trước bằng
              tiếng Anh. Khả năng hỗ trợ tiếng Việt hoặc các tính năng cụ thể
              còn phụ thuộc vào lịch triển khai của Apple.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Camera iPhone Duo có gì mới?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-camera-kep-48mp.webp"
                alt="iphone-duo-camera-kep-48mp"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Thay vì hệ thống ba camera Pro Fusion như iPhone 18 Pro Series,
              iPhone Duo sử dụng hệ thống <strong>48MP Dual Fusion</strong> gồm
              Fusion Main và Fusion Ultra Wide.
            </p>

            <p>
              Điểm mạnh của camera trên Duo không chỉ nằm ở cảm biến mà còn ở
              việc Apple tận dụng thiết kế hai màn hình để tạo ra những cách
              chụp mới.
            </p>

            <h3>
              <strong>Camera chính 48MP Fusion Main</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-camera-48mp.webp"
                alt="iphone-duo-camera-48mp"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Camera Main có độ phân giải 48MP, tiêu cự 26mm và khẩu độ ƒ/1,6.
              Hệ thống hỗ trợ chống rung quang học dịch chuyển cảm biến, Hybrid
              Focus Pixels và ảnh độ phân giải 24MP hoặc 48MP.
            </p>

            <p>
              Từ cảm biến chính, máy cũng cung cấp mức Telephoto 2x chất lượng
              quang học tương đương tiêu cự 52mm.
            </p>

            <p>
              Khác với iPhone 18 Pro, Duo không có camera Telephoto chuyên dụng.
              Vì vậy, người dùng ưu tiên khả năng zoom xa nên cân nhắc sự khác
              biệt này trước khi lựa chọn.
            </p>

            <h3>
              <strong>Camera Ultra Wide 48MP và macro</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-camera-anh-chup-che-do-Photographic-Styles-3.webp"
                alt="iphone-duo-camera-anh-chup-che-do-Photographic-Styles-3"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Camera Fusion Ultra Wide có độ phân giải 48MP, tiêu cự 13mm, khẩu
              độ ƒ/2,2 và trường nhìn 120 độ.
            </p>

            <p>
              Camera phù hợp với phong cảnh, kiến trúc, ảnh nhóm và macro. Hệ
              thống hỗ trợ ảnh độ phân giải 24MP và 48MP.
            </p>

            <h3>
              <strong>Duo Preview tận dụng màn hình ngoài khi chụp ảnh</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-selfie-de-dang-voi-camera-sau.webp"
                alt="iphone-duo-selfie-de-dang-voi-camera-sau"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Một trong những lợi thế riêng của thiết kế gập là{" "}
              <strong>Duo Preview</strong>. Khi sử dụng camera sau để chụp một
              người khác, màn hình ngoài có thể hiển thị ảnh xem trước để chủ
              thể nhìn thấy khung hình.
            </p>

            <p>
              Điều này đặc biệt hữu ích khi chụp chân dung, ảnh nhóm hoặc quay
              nội dung có người đứng phía trước camera.
            </p>

            <h3>
              <strong>Chụp Thông Minh và Thu Hút Trẻ</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-tu-tim-chan-dung-nguoi-chup.webp"
                alt="iphone-duo-tu-tim-chan-dung-nguoi-chup"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Apple bổ sung một số tính năng camera riêng cho Duo, bao gồm Chụp
              Thông Minh và Thu Hút Trẻ.
            </p>

            <p>
              Chụp Thông Minh hướng đến khả năng tự động hỗ trợ ghi lại khoảnh
              khắc mà không cần người dùng liên tục thao tác nút chụp. Thu Hút
              Trẻ sử dụng hình ảnh động trên màn hình để thu hút sự chú ý của
              trẻ khi chụp ảnh.
            </p>

            <p>
              Đây là ví dụ rõ ràng cho việc thiết kế hai màn hình tạo ra những
              tính năng mà iPhone dạng thanh truyền thống khó triển khai theo
              cùng cách.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>iPhone Duo có hai camera trước</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-facetime-ranh-tay.webp"
                alt="iphone-duo-facetime-ranh-tay"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone Duo có camera trước 12MP Center Stage trên màn hình ngoài
              và camera FaceTime đặt dưới màn hình trong.
            </p>

            <p>
              Camera ngoài phù hợp với selfie, gọi video và quay nội dung khi
              máy đang đóng. Khi mở máy, camera dưới màn hình giúp người dùng
              thực hiện cuộc gọi FaceTime mà không cần một phần khoét lớn trên
              màn hình 7,6 inch.
            </p>

            <p>
              Apple cũng phát triển Duo FaceTime để tận dụng nhiều người trong
              khung hình và các góc đặt máy khác nhau.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>iPhone Duo quay video có tốt không?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/Smart-focus-tracking-tren-iphone-duo.webp"
                alt="Smart-focus-tracking-tren-iphone-duo"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Camera chính hỗ trợ quay video 4K Dolby Vision ở nhiều tốc độ
              khung hình và có thể đạt 100 hoặc 120 fps bằng Fusion Main.
            </p>

            <p>Một số khả năng đáng chú ý gồm:</p>

            <ul>
              <li>4K Dolby Vision.</li>
              <li>4K Dolby Vision 100 fps và 120 fps với Fusion Main.</li>
              <li>Chế độ Điện Ảnh lên đến 4K 60 fps.</li>
              <li>Chế độ Hành Động lên đến 2.8K 60 fps.</li>
              <li>Slow motion 4K 120 fps.</li>
              <li>Ghi Hình Kép lên đến 4K 30 fps.</li>
              <li>Video macro.</li>
              <li>Spatial Audio và Audio Mix.</li>
              <li>Giảm tiếng gió.</li>
            </ul>

            <p>
              Duo không được định vị giống hệ thống camera Pro của iPhone 18 Pro
              và Pro Max. Thay vào đó, thế mạnh nằm ở sự linh hoạt khi quay bằng
              nhiều màn hình và nhiều tư thế đặt máy.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Touch ID trở lại trên iPhone Duo</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-touch-id-mo-man-hinh.webp"
                alt="iphone-duo-touch-id-mo-man-hinh"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone Duo sử dụng <strong>Touch ID tích hợp vào nút sườn</strong>{" "}
              thay vì Face ID.
            </p>

            <p>
              Cách bố trí này giúp người dùng xác thực thiết bị khi máy đang
              đóng, mở hoặc đặt ở nhiều góc khác nhau mà không phụ thuộc vào
              việc camera có hướng trực tiếp về phía khuôn mặt.
            </p>

            <p>
              Đây là một lựa chọn phù hợp với đặc điểm form factor gập, đồng
              thời tạo ra sự khác biệt đáng kể so với dòng iPhone 18 Pro.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Hệ thống pin đôi hoạt động thế nào?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-co-2-vien-pin.webp"
                alt="iphone-duo-co-2-vien-pin"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone Duo là mẫu iPhone đầu tiên sử dụng{" "}
              <strong>hệ thống pin đôi</strong>. Hai cell pin được bố trí trong
              hai phần của thân máy nhằm tận dụng không gian bên trong thiết kế
              gập.
            </p>

            <p>
              Apple đồng thời sử dụng thiết kế chỉ eSIM để giải phóng thêm không
              gian và modem C2 nhằm cải thiện hiệu quả sử dụng năng lượng.
            </p>

            <p>Thời lượng pin phụ thuộc đáng kể vào màn hình được sử dụng:</p>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "16px",
              }}
            >
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Tình huống
                  </th>

                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Thời lượng Apple công bố
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Xem video bằng màn hình trong
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Lên đến 31 giờ
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Xem video bằng màn hình ngoài
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Lên đến 44 giờ
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Streaming bằng màn hình trong
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Lên đến 26 giờ
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Streaming bằng màn hình ngoài
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Lên đến 37 giờ
                  </td>
                </tr>
              </tbody>
            </table>

            <p>
              Sự chênh lệch này cho thấy cách sử dụng hai màn hình ảnh hưởng
              trực tiếp đến pin. Những tác vụ đơn giản không cần màn hình 7,6
              inch có thể thực hiện trên màn hình ngoài để tối ưu thời lượng sử
              dụng.
            </p>

            <h3>
              <strong>Sạc 50% trong khoảng 20 phút</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-stand-by.webp"
                alt="iphone-duo-stand-by"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Apple công bố iPhone Duo có thể sạc lên đến 50% trong khoảng 20
              phút khi sử dụng bộ tiếp hợp tương thích từ 60W trở lên.
            </p>

            <p>
              Máy cũng hỗ trợ MagSafe và Qi2 với công suất sạc không dây lên đến
              25W trong điều kiện tương thích.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>iPhone Duo chỉ sử dụng eSIM</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-cau-truc-ben-trong-cung-cap.webp"
                alt="iphone-duo-cau-truc-ben-trong-cung-cap"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Khác với một số phiên bản iPhone truyền thống, iPhone Duo{" "}
              <strong>không hỗ trợ SIM vật lý trên toàn cầu</strong>.
            </p>

            <p>
              Máy sử dụng eSIM và có thể lưu nhiều cấu hình thuê bao. Thiết kế
              này giúp Apple tiết kiệm không gian bên trong để dành cho pin và
              các thành phần của cơ chế gập.
            </p>

            <p>
              Người dùng đang sử dụng SIM vật lý nên kiểm tra khả năng chuyển
              sang eSIM với nhà mạng trước khi lựa chọn Duo.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Kết nối Wi-Fi 7, Bluetooth 6 và USB 3</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-phu-kien-op-lung-bao-da-co-ke-dung.webp"
                alt="iphone-duo-phu-kien-op-lung-bao-da-co-ke-dung"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone Duo sử dụng chip mạng Apple N1 và modem C2, hỗ trợ Wi-Fi 7,
              Bluetooth 6, Thread, 5G, Ultra Wideband thế hệ thứ hai, NFC và GPS
              hai tần số.
            </p>

            <p>
              Cổng USB-C hỗ trợ USB 3 với tốc độ truyền dữ liệu lên đến 10Gb/s
              và DisplayPort.
            </p>

            <p>
              Khả năng truyền dữ liệu tốc độ cao đặc biệt hữu ích với người dùng
              thường xuyên làm việc với ảnh, video hoặc cần kết nối thiết bị
              ngoài.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>iPhone Duo có những dung lượng nào?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-tuy-chinh-cac-widgets.webp"
                alt="iphone-duo-tuy-chinh-cac-widgets"
                style={{ width: "100%" }}
              />
            </figure>

            <p>Apple cung cấp bốn mức dung lượng lưu trữ:</p>

            <ul>
              <li>
                <strong>256GB:</strong> phù hợp với nhu cầu hàng ngày và người
                sử dụng cloud thường xuyên.
              </li>
              <li>
                <strong>512GB:</strong> cân bằng cho người lưu nhiều ảnh, video,
                game và tài liệu.
              </li>
              <li>
                <strong>1TB:</strong> phù hợp với power user, creator hoặc người
                cần nhiều nội dung offline.
              </li>
              <li>
                <strong>2TB:</strong> hướng đến người cần lưu lượng dữ liệu rất
                lớn và muốn hạn chế phụ thuộc vào cloud.
              </li>
            </ul>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "16px",
              }}
            >
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Dung lượng
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Phù hợp với ai?
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    256GB
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Sử dụng hàng ngày, có dùng iCloud
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    512GB
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Đa nhiệm, nhiều game, ảnh/video và tài liệu
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    1TB
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Creator, power user, nhiều nội dung offline
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    2TB
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Khối lượng dữ liệu lớn, sử dụng chuyên sâu
                  </td>
                </tr>
              </tbody>
            </table>

            <h2>
              <strong style={{fontSize: '22px'}}>iPhone Duo và iPhone 18 Pro Max khác nhau gì?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iphone-duo-mo-2-man-tren-tay.webp"
                alt="iphone-duo-mo-2-man-tren-tay"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone Duo và iPhone 18 Pro Max đều sử dụng A20 Pro nhưng phục vụ
              hai trải nghiệm rất khác nhau.
            </p>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "16px",
              }}
            >
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Tiêu chí
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    iPhone Duo
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    iPhone 18 Pro Max
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Thiết kế
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Gập
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Dạng thanh truyền thống
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màn hình chính
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    7,6 inch khi mở
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    6,9 inch
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màn hình phụ
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    5,4 inch
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Không
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Chip
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    A20 Pro
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    A20 Pro
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera sau
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Dual Fusion
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Pro Fusion với Telephoto
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Zoom chất lượng quang học
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Đến 2x
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Đến 8x
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Sinh trắc học
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Touch ID
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Face ID
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Apple Pencil
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Hỗ trợ Apple Pencil USB-C
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Không
                  </td>
                </tr>

                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Thế mạnh
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màn hình lớn, đa nhiệm, form factor linh hoạt
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera Pro, Telephoto, trải nghiệm truyền thống
                  </td>
                </tr>
              </tbody>
            </table>

            <p>
              Duo phù hợp hơn nếu màn hình lớn, khả năng gập và đa nhiệm là ưu
              tiên. Pro Max có lợi thế nếu hệ thống camera chuyên sâu và khả
              năng zoom xa quan trọng hơn.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>iPhone Duo phù hợp với ai?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/thiet-ke-doc-khien-iphone-duo-trong-dep-sang-tao.webp"
                alt="thiet-ke-doc-khien-iphone-duo-trong-dep-sang-tao"
                style={{ width: "100%" }}
              />
            </figure>

            <ul>
              <li>
                <strong>Người muốn trải nghiệm iPhone màn hình gập:</strong> Duo
                mang đến form factor hoàn toàn mới trong hệ sinh thái Apple.
              </li>

              <li>
                <strong>Người thường xuyên đa nhiệm:</strong> màn hình 7,6 inch
                phù hợp hơn với việc sử dụng nhiều ứng dụng và nội dung cùng
                lúc.
              </li>

              <li>
                <strong>Người làm việc trên điện thoại:</strong> không gian hiển
                thị lớn, Apple Pencil và nhiều tư thế đặt máy tạo thêm lựa chọn
                cho công việc.
              </li>

              <li>
                <strong>Người xem nhiều nội dung:</strong> màn hình trong lớn
                hơn 50% so với iPhone 18 Pro Max.
              </li>

              <li>
                <strong>Gamer:</strong> A20 Pro, màn hình 120Hz và hệ thống tản
                nhiệt buồng hơi hỗ trợ các phiên chơi kéo dài.
              </li>

              <li>
                <strong>Early adopter:</strong> phù hợp với người muốn trải
                nghiệm những thay đổi lớn nhất trong cách sử dụng iPhone.
              </li>
            </ul>

            <h2>
              <strong style={{fontSize: '22px'}}>
                Ai nên cân nhắc iPhone 18 Pro thay vì iPhone Duo?
              </strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/zoom-2x-tren-camera-iphone-duo.webp"
                alt="zoom-2x-tren-camera-iphone-duo"
                style={{ width: "100%" }}
              />
            </figure>

            <p>iPhone Duo không phải lựa chọn tốt hơn cho mọi nhu cầu.</p>

            <p>
              Người ưu tiên camera Telephoto, khả năng zoom xa hoặc muốn một
              thiết bị nhẹ và đơn giản hơn có thể phù hợp với iPhone 18 Pro
              Series.
            </p>

            <p>
              Pro và Pro Max cũng sử dụng thiết kế dạng thanh quen thuộc, trong
              khi Duo yêu cầu người dùng làm quen với kích thước, trọng lượng và
              cách tương tác mới của thiết bị gập.
            </p>

            <p>
              Do đó, giá trị lớn nhất của Duo nằm ở màn hình và form factor,
              không phải việc vượt trội toàn diện về mọi thành phần phần cứng.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Có nên đặt cọc iPhone Duo?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iPhone-Duo-Night-Sky.webp"
                alt="iPhone-Duo-Night-Sky"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone Duo đáng cân nhắc với người thực sự muốn khai thác lợi thế
              của màn hình gập. Thiết bị mang lại không gian hiển thị 7,6 inch,
              khả năng sử dụng nhiều tư thế, hỗ trợ đa nhiệm và Apple Pencil,
              trong khi vẫn giữ chip A20 Pro cùng hệ sinh thái iOS.
            </p>

            <p>
              Tuy nhiên, nếu nhu cầu chính là camera Telephoto, thiết kế nhẹ hơn
              hoặc trải nghiệm iPhone truyền thống, dòng iPhone 18 Pro có thể
              phù hợp hơn.
            </p>

            <p>
              Tại thời điểm hiện tại, ShopDunk đang hiển thị iPhone Duo ở trạng
              thái đăng ký nhận tin. Apple công bố thời gian đặt trước tại Việt
              Nam từ 19:00 ngày 16/10/2026 và dự kiến có hàng từ ngày
              23/10/2026. Người dùng nên theo dõi chính sách đặt cọc và ưu đãi
              tại ShopDunk khi chương trình chính thức được công bố.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Câu hỏi thường gặp về iPhone Duo</strong>
            </h2>

            <h3>
              <strong>
                iPhone Duo có phải iPhone màn hình gập đầu tiên không?
              </strong>
            </h3>

            <p>
              Có. Apple giới thiệu iPhone Duo là chiếc iPhone màn hình gập đầu
              tiên của hãng.
            </p>

            <h3>
              <strong>iPhone Duo có mấy màn hình?</strong>
            </h3>

            <p>
              Máy có màn hình trong Super Retina XDR OLED gập 7,6 inch và màn
              hình ngoài Super Retina XDR OLED 5,4 inch. Cả hai đều hỗ trợ
              ProMotion lên đến 120Hz.
            </p>

            <h3>
              <strong>iPhone Duo dùng chip gì?</strong>
            </h3>

            <p>
              iPhone Duo sử dụng chip A20 Pro với CPU 6 lõi, GPU 7 lõi tích hợp
              Neural Accelerators và Bộ Đôi Neural Engine 16 lõi.
            </p>

            <h3>
              <strong>iPhone Duo có camera Telephoto không?</strong>
            </h3>

            <p>
              Không có camera Telephoto chuyên dụng. Camera Main 48MP cung cấp
              mức 2x chất lượng quang học, trong khi hệ thống camera sau gồm
              Main và Ultra Wide.
            </p>

            <h3>
              <strong>iPhone Duo có Face ID không?</strong>
            </h3>

            <p>
              Không. Apple sử dụng Touch ID tích hợp vào nút sườn trên iPhone
              Duo.
            </p>

            <h3>
              <strong>iPhone Duo có dùng SIM vật lý không?</strong>
            </h3>

            <p>Không. iPhone Duo chỉ hỗ trợ eSIM trên toàn cầu.</p>

            <h3>
              <strong>iPhone Duo có hỗ trợ Apple Pencil không?</strong>
            </h3>

            <p>
              Có. Apple công bố iPhone Duo tương thích với Apple Pencil USB-C,
              với khả năng hỗ trợ được triển khai sau trong năm.
            </p>

            <h3>
              <strong>iPhone Duo có những dung lượng nào?</strong>
            </h3>

            <p>
              Máy có bốn tùy chọn dung lượng gồm 256GB, 512GB, 1TB và 2TB.
            </p>

            <h3>
              <strong>Pin iPhone Duo dùng được bao lâu?</strong>
            </h3>

            <p>
              Theo Apple, thiết bị có thể xem video tối đa 31 giờ khi sử dụng
              màn hình trong và tối đa 44 giờ khi sử dụng màn hình ngoài. Thời
              lượng thực tế sẽ phụ thuộc vào cách sử dụng.
            </p>

            <h3>
              <strong>iPhone Duo hay iPhone 18 Pro Max tốt hơn?</strong>
            </h3>

            <p>
              Hai thiết bị phù hợp với nhu cầu khác nhau. Duo có lợi thế về màn
              hình gập, đa nhiệm và Apple Pencil, trong khi Pro Max mạnh hơn về
              hệ thống camera với Telephoto và zoom chất lượng quang học lên đến
              8x.
            </p>
          </>
        )}
      </div>

      <div className="all-toggle-btn">
        <button
          className="toggle-btn"
          onClick={() => setShowMore(!showMore)}
        >
          {showMore ? "Thu gọn" : "Xem thêm"}
        </button>
      </div>

      <style>{`
        .content.collapsed {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .toggle-btn {
          margin-top: 10px;
          padding: 8px 16px;
          border: none;
          border-radius: 80px;
          cursor: pointer;
          background: #037CF6;
          color: #fff;
        }
      `}</style>
    </div>
  );
}

const DuoMaxInfo = DuoInfo;

export default DuoMaxInfo;